/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { Suspense, useEffect, useState } from 'react';
import { i18n } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import loreei18n from './i18n/i18n';
import './App.scss';
import '../src/assets/font/customFont.css';
import '../src/assets/scss/fontawesome.min.css';
import Routing from './routes/index';
import { useDispatch } from 'react-redux';
import {
  setCustomConfiguration,
  setData,
  setInteractiveState,
  setToken,
} from './redux/parentDataSlice';
import { attachCustomFontUrl, isValidHost } from './middleware/utils';
import { getAuthenticationToken, userVerification } from './middleware/api';
import CircleLoader from './components/loader/loader';
import { Row } from 'react-bootstrap';

function App() {
  const [i18nValue, setI18nValue] = useState<i18n | null>(null);
  const loaderType = window.location.href.includes('edit') ? '' : 'tableViewLoader';
  const dispatch = useDispatch();
  const isLoaderVisible =
    window.location.href.includes('/edit') || window.location.href.includes('/interactives');
  const [isCustomConfigSet, setIsCustomConfigSet] = useState(isLoaderVisible);
  const transformCustomConfiguration = (input: any) => {
    const { configsList, ...permissions } = input;

    return {
      customConfiguration: {
        config: {
          ...permissions,
          create:
            input.globalinteractivecreate ||
            input.myinteractivecreate ||
            input.collaborativeinteractivecreate ||
            false,
          delete:
            input.globalinteractivedelete ||
            input.myinteractivedelete ||
            input.sharedinteractivedelete ||
            false,

          duplicate:
            input.globalinteractiveduplicate ||
            input.myinteractiveduplicate ||
            input.sharedinteractiveduplicate ||
            false,

          edit:
            input.globalinteractiveedit ||
            input.myinteractiveedit ||
            input.sharedinteractiveedit ||
            false,
        },

        customHeaderStyleList: configsList?.customHeaderStyle,
        customLinkStyleList: configsList?.customLinkStyle?.customLink ?? [],
        fontFamilyList: configsList?.customFonts,
      },
    };
  };

  useEffect(() => {
    loreei18n.then((i) => setI18nValue(i)).catch((e) => new Error(e));
    let isSameWindow = true;
    console.log('App component mounted, checking window context');
    try {
      console.log(window.self, window.top, window.self !== window.top, 'test');
      isSameWindow = window.self !== window.top;
    } catch (e) {
      console.log('eerror', e);
      isSameWindow = true;
    }

    if (!isSameWindow) {
      setIsCustomConfigSet(false);
      return;
    }
    const handleMessage = async (event: MessageEvent) => {
      console.log('Received message event:', event);
      let origin = event.origin || process.env.REACT_APP_ORIGIN;
      console.log('Determined origin:', origin);
      if (!origin) return;
      console.log('Received LOREE_WINDOW_SIZE message:', event.data);
      console.log('event.data:', event.data.type);
      if (event.data?.type === 'LOREE_WINDOW_SIZE') {
        const frames = document.getElementsByTagName('iframe');
        console.log('Found frames:', frames);
        Array.from(frames).forEach((frame) => {
          if (
            frame.src &&
            frame.contentWindow === event.source &&
            frame.src.startsWith(event.data.url)
          ) {
            frame.style.height = event.data.height.toString() + 'px';
          }
        });
      } else if (
        event.data &&
        event.data.type === 'loreeDetails' &&
        event.data.source === 'parent-page'
      ) {
        const { loreeUserEmail, userEmail, orgId } = event.data;
        dispatch(setData(event.data));
        attachCustomFontUrl(event.data.ltiPlatformId);
        dispatch(setToken(await getAuthenticationToken(loreeUserEmail, userEmail, orgId)));
        const configData = await userVerification(userEmail, orgId);
        console.log('Config data received from userVerification:', configData);
        const parsed = JSON.parse(configData.featureConfig);
        const maptedData = transformCustomConfiguration(parsed);
        dispatch(setCustomConfiguration(maptedData.customConfiguration));
        dispatch(setInteractiveState(event.data.isCollab ? 'collaborative' : ''));
        setIsCustomConfigSet(false);
      } else {
        console.log('Received unknown message type:', event.data?.type);
        setIsCustomConfigSet(false);
      }
    };

    window.addEventListener('message', handleMessage);
    console.log('added event listener');
    const validOrigin = isValidHost(document.referrer)
      ? document.referrer
      : process.env.REACT_APP_DEV_MODE;
    if (validOrigin) {
      window.parent.postMessage({ type: 'child-ready' }, validOrigin);
    }
    return () => {
      console.log('Cleaning up event listener');
      window.removeEventListener('message', handleMessage);
    };
  }, [dispatch]);
  if (i18nValue === null) return <></>;

  if (isCustomConfigSet) {
    return (
      <Row
        className={`${
          loaderType === 'tableViewLoader' ? 'margin landingPageLoreeInteractive' : 'edit'
        }`}
      >
        <CircleLoader loaderType={loaderType} />
      </Row>
    );
  }
  return (
    <I18nextProvider i18n={i18nValue}>
      <Suspense fallback={<></>}>
        <Routing />
      </Suspense>
    </I18nextProvider>
  );
}

export default App;
